export const API_RESULT_MODAL_EVENT = 'greenflow:api-result-modal';

export type ApiResultModalDetail = {
  message: string;
  success: boolean;
  /** Invoked when the user taps OK (not backdrop). */
  onDismiss?: () => void;
};

/** Show a global modal for API result (`error: true/false` on HTTP 200). */
export function showApiResultModal(detail: ApiResultModalDetail) {
  window.dispatchEvent(
    new CustomEvent<ApiResultModalDetail>(API_RESULT_MODAL_EVENT, {
      detail,
    }),
  );
}
